import alertTriggerUIStore from './alertTriggerUIStore.js';
import alertTriggerDataStore from './alertTriggerDataStore.js';

export default {
  modules: {
    ui: alertTriggerUIStore,
    data: alertTriggerDataStore,
  },
};
